export const GET_PRICING_INFO = "get_pricing_info";
export const GET_PRICING_INFO_SUCCESSFUL = "get_pricing_info_successful";
export const GET_PRICING_INFO_FAILED = "get_pricing_info_failed";